import { ReactNode, useEffect, useState } from 'react';

import SignInContext from './SignInContext';

interface Props {
    children?: ReactNode;
}

function SignInContextProvider({ children }:Props) {
    const useVerified = useState<boolean>(false);
    const useValue = useState<string>('');
    const useInputValue = useState<string>('');
    const useInputAuthCode = useState<string>('');
    return (
        <SignInContext value={{
            useVerified,
            useValue,
            useInputValue,
            useInputAuthCode,
        }}>
            {children}
        </SignInContext>
    );
}

export default SignInContextProvider;
